import { AnyAction, combineReducers, Reducer } from 'redux';
import { RouterState } from 'redux-first-history';
import { NonNullableRouterState, State } from '../../types/state';
import { RootActionType } from '../rootActions';
import annotation from './annotation/reducer';
import bbox from './bboxes/reducer';
import beforeLeave from './beforeLeave/reducer';
import datapoints from './datapoints/reducer';
import groups from './groups/reducer';
import locale from './locale/reducer';
import modal from './modal/reducer';
import organization from './organization/reducer';
import organizationGroup from './organizationGroup/reducer';
import productTour from './productTour/reducer';
import schema from './schema/reducer';
import search from './search/reducer';
import searchAndReplace from './searchAndReplace/reducer';
import stack from './stack/reducer';
import statistics from './statistics/reducer';
import ui from './ui/reducer';
import user from './user/reducer';
import validationMessages from './validationMessages/reducer';

export default (router: Reducer<RouterState, AnyAction>) => {
  const reducers: {
    [A in keyof State]: Reducer<State[A], RootActionType>;
  } = {
    annotation,
    bbox,
    datapoints,
    groups,
    locale,
    modal,
    organization,
    organizationGroup,
    // Is it ok to consider non-nullable? It gets filled in the first action.
    router: router as Reducer<NonNullableRouterState, AnyAction>,
    schema,
    search,
    searchAndReplace,
    stack,
    statistics,
    productTour,
    ui,
    user,
    validationMessages,
    beforeLeave,
  };

  return combineReducers(reducers);
};
